import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  activationCodeBtn: {
    borderRadius: '0 .25rem .25rem 0'
  },
  statusInfoAccordion: {
    backgroundColor: theme.vars.palette.background.elevation1,
    margin: '0.5rem 0 0.5rem 0',
    padding: '0 1rem 1rem'
  },
  cardGridLayoutWrapper: {
    '&>.MuiGrid-root': {
      marginBottom: '1rem'
    },
    '& .MuiGrid-root:last-child': {
      marginBottom: '0rem'
    }
  },
  cardGridLayout: {
    paddingLeft: '.5rem',
    paddingTop: '1rem',
    paddingRight: '.5rem'
  },
  styledCardHeader: {
    borderBottom: `2px solid ${theme.palette.divider}`,
    width: '100%'
  },
  styledCard: {
    backgroundColor: 'theme.palette.background.elevation2',
    padding: '1rem',
    marginBottom: '.5rem'
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem',
    alignItems: 'center'
  },
  dFlex: {
    display: 'flex',
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word',
    alignItems: 'center'
  },
  flexLeftCol: {
    flex: 0.4
  },
  flexRightCol: {
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word'
  },
  token: {
    whiteSpace: 'nowrap',
    width: '10.25rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '.5rem'
  },
  statusInfoAccordionDetails: {
    backgroundColor: theme.vars.palette.background.elevation2
  }
}));

export default useStyles;
